import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from "@ngrx/store"
import { State } from "."

export const stepsValidityStateFeaturekey = 'stepsValidity'

export interface StepsValidityState {
  [key: string]: 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED'
}

export const updateStepValidityAction = createAction(
  '[Form Core Module] Update Step Validity',
  props<StepsValidityState>()
)

const initialStepsValidityState: StepsValidityState = {}

export const stepsValidityStateReducer = createReducer(
  initialStepsValidityState,
  on(updateStepValidityAction, (state, action) => {
    const _obj = {...state}
    for (let step in action) {
      if (step !== 'type') _obj[step] = action[step]
    }
    return _obj
  })
)

export const selectStepsValidity = createFeatureSelector<State, StepsValidityState>(stepsValidityStateFeaturekey)
export const selectStepValidity = (step: string) => {
  return createSelector(
    selectStepsValidity,
    (stepsValidity: StepsValidityState) => stepsValidity[step]
  )
}